import React from 'react'
import { Link } from 'react-router-dom'
import './WhatWeBuild.css'
import RichTextContent, { CmsText } from '../../../RichTextContent/RichTextContent'
import { useIndustrySection } from '../../../../context/IndustryPageContext'
import { getListItemsFromSection } from '../../../../services/contentApi'

const WhatWeBuild = () => {
  const { section, loading } = useIndustrySection('what-we-build')

  if (loading || !section?.fields) return null

  const fields = section.fields
  const items = getListItemsFromSection(section)
  const midpoint = Math.ceil(items.length / 2)
  const leftColumn = items.slice(0, midpoint)
  const rightColumn = items.slice(midpoint)

  return (
    <section className="whatwebuild">
      <div className="wwb-container">
        <div className="wwb-left">
          {fields.subtitle ? (
            <CmsText
              content={fields.subtitle}
              as="p"
              className="wwb-subtitle"
            />
          ) : null}

          {fields.title ? (
            <CmsText content={fields.title} as="h2" className="wwb-title" />
          ) : null}

          {fields.description ? (
            <RichTextContent
              content={fields.description}
              className="wwb-description"
            />
          ) : null}

          <div className="wwb-features">
            <div className="wwb-col">
              {leftColumn.map((item, index) => (
                <div className="wwb-item" key={index}>
                  <span className="wwb-check">✓</span>
                  <CmsText content={item} as="p" />
                </div>
              ))}
            </div>

            <div className="wwb-col">
              {rightColumn.map((item, index) => (
                <div className="wwb-item" key={index}>
                  <span className="wwb-check">✓</span>
                  <CmsText content={item} as="p" />
                </div>
              ))}
            </div>
          </div>

          {fields.buttonLink ? (
            <Link to={fields.buttonLink} className="wwb-btn buttonclip">
              <CmsText content={fields.buttonText} as="span" />
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  )
}

export default WhatWeBuild
